import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export const toCleanTimeZone = (date: Date) => zonedTimeToUtc(date, "Etc/UTC");
export const toCleanUtc = (date: Date) => utcToZonedTime(date, "Etc/UTC");
